import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/rootReducer';

export const selectMediaQuery = createSelector(
  ({ mediaQuery }: RootState) => ({ mediaQuery }),
  ({ mediaQuery }) => {
    return mediaQuery;
  }
);

export const selectPutInSmall = createSelector(
  ({ mediaQuery }: RootState) => ({ mediaQuery }),
  ({ mediaQuery }) => {
    return !!mediaQuery.sm;
  }
);

export const selectInnerHeight = createSelector(
  ({ mediaQuery }: RootState) => ({ mediaQuery }),
  ({ mediaQuery }) => {
    return mediaQuery.innerHeight;
  }
);
